import type {CohortVisitLinkTriggerStruct} from '@cohort/shared/apps/cohort/triggers/visitLink';
import type {ActionCtaComponentProps} from '@cohort/wallet/apps/TriggerIntegration';
import OpenCtaUnverified from '@cohort/wallet/components/challenges/OpenCtaUnverified';
import {useTranslation} from 'react-i18next';

const CohortVisitLinkTriggerIntegrationActionCtaComponent: React.FC<
  ActionCtaComponentProps<CohortVisitLinkTriggerStruct>
> = ({config, processStepVerification, trackingMetadata}) => {
  const {t} = useTranslation('app-cohort', {
    keyPrefix: 'triggerIntegrations.visit-link',
  });

  return (
    <OpenCtaUnverified
      url={config.url}
      ctaTitle={t('ctaTitle')}
      processStepVerification={processStepVerification}
      trackingMetadata={trackingMetadata}
    />
  );
};

export default CohortVisitLinkTriggerIntegrationActionCtaComponent;
